import { createFileRoute } from "@tanstack/react-router";
import GettingHerePage from "@/components/GettingHerePage";

const URL = "https://www.travelbackland.com/getting-here";

export const Route = createFileRoute("/getting-here")({
  head: () => ({
    meta: [
      { title: "Getting Here — The Drive In to Backland" },
      {
        name: "description",
        content:
          "How to find us: directions from Williams, AZ to Backland, what to expect on the forest road, and an interactive map of the route in.",
      },
      { property: "og:title", content: "Getting to Backland" },
      {
        property: "og:description",
        content:
          "The journey in — 160 private acres tucked into pristine National Forest. Here's how to get here.",
      },
      { property: "og:url", content: URL },
      { property: "og:type", content: "article" },
      {
        property: "og:image",
        content:
          "https://www.travelbackland.com/__l5e/assets-v1/5a8c904d-9fd4-4bbf-85ed-2a0f99e4fa33/path-hero.jpg",
      },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: GettingHerePage,
});
